module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAqCAYAAACtMEtjAAAAAXNSR0IArs4c6QAAAV9JREFUWAntmLlOxDAQhrEdKpatEBJIUZrlETgKHmXp6Kk5Sq73gEeh4XgDKBIlokBUgESTg28iZK3EpjC2trKlKOOZ8f9nfqewRy0xyrLcbdv2EnOn67qR+HyHUuoLjAet9Umapveqqqq9pmnuIDAEChI+fUlkPXirvDLwGmPMflLX9TUOg+Mgy7JbSQo1iqKYQngjHIqJlPgByWYoglkc8F+ZjxMYV6jmG8fRbEJAe7nnyPO8Cwg6CJX8Rt54nw5m+QUuWL6upCKke2GPtvzw5q9mS56RbqLnh8N7I9G/NY3SRemsAvFnsFK4GlE6V8VsfpTOSuFqROlcFbP5UTorhasRpXNVzOb3h3zOxmPO4IfWG9AQbIHrD/kBcQeh+oq4TbyTcT6Y5Rc4o6o1xbViIVdLDdsTzwaEU78P/7taMAVbOBZ2/VfyHdLQoNdwxV5twx6soQHWIz2GY2lo/ABpJZ4buU+LNQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_phone.png
// module id = p78i
// module chunks = 3